export default "__VITE_PUBLIC_ASSET__40ea9f32__"